import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";

/**
 * Returns true when the current loan status sequence is greater than the target status.
 * @param targetStatusCode - Reference status code (e.g. screen status)
 * @param currentStatusCode - Optional; defaults to register.loan_status
 */
const useIsLoanStatusAfter = (
  targetStatusCode: string,
  currentStatusCode?: string,
): boolean => {
  const statusConfig = useSelector((state: RootState) => state.app.status_config);
  const loanStatus = useSelector((state: RootState) => state.register.loan_status);
  const currentCode = currentStatusCode ?? loanStatus;

  return useMemo(() => {
    const current = statusConfig.find((s) => s.code === currentCode);
    const target = statusConfig.find((s) => s.code === targetStatusCode);

    if (!current || !target) {
      return false;
    }

    return current.sequence > target.sequence;
  }, [statusConfig, currentCode, targetStatusCode]);
};

export default useIsLoanStatusAfter;
